import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/faq-icon.svg'
import _imports_1 from '@/assets/img/menu.svg'


const _withScopeId = n => (_pushScopeId("data-v-8b58e48a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "top-user-menu",
  "data-test": "orcas-migration-top-user-menu"
}
const _hoisted_2 = ["href"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "top-user-menu-icon",
  src: _imports_0,
  alt: "question mark icon"
}, null, -1 /* HOISTED */))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "top-user-menu-link" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "top-menu-icon",
  src: _imports_1,
  alt: "question mark icon"
}, null, -1 /* HOISTED */))
const _hoisted_7 = [
  _hoisted_6
]

import UserMenu from '@/layouts/AppLayoutHeader/components/UserMenu.vue'
import { ANALYTICS_EVENTS } from '@/services/analyticsEvents'
import { analytics } from '@/services/analyticsProvider'
import NotificationCenter from '@/notifications/NotificationCenter.vue'
import { useFaqUrl } from '@/components/sennderUrlHelper'


export default /*#__PURE__*/_defineComponent({
  __name: 'TopMenu',
  props: {
  isMobileLayout: { type: Boolean, required: true },
},
  emits: ['toggle-menu'],
  setup(__props, { emit: emits }) {





const toggleMenu = () => {
  emits('toggle-menu')
}

const faqUrl = useFaqUrl()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(NotificationCenter),
    (!__props.isMobileLayout)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: _unref(faqUrl),
          target: "_blank",
          class: "top-user-menu-link",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(analytics).trackEvent(_unref(ANALYTICS_EVENTS).MENU_FAQ_CLICK)))
        }, _hoisted_4, 8 /* PROPS */, _hoisted_2))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(UserMenu)
    ]),
    (__props.isMobileLayout)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "top-menu-list",
          onClick: toggleMenu
        }, _hoisted_7))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})